// extracted by mini-css-extract-plugin
export default {"root":"styles_root__iVqVQ","content":"styles_content__WBEnm","message":"styles_message__kD0mQ","actions":"styles_actions__gQD+G"};